<template>
  <div class="offer" v-if="offer">
    <div class="row">
      <div class="large-1 columns offer-drag-handle">&#x2630;</div> 
      <div class="large-9 columns short-name">
        {{ localOffer.shortName }}
      </div>
      <div class="large-4 columns type-name">
        {{ getOfferTypeName() }}
      </div>
      <div class="large-6 columns action-buttons">
        <div class="row">
          <div class="large-10 columns action-button" @click="editOfferStart">
            <i class="ig_icons dark-grey edit"></i>
            <span>{{translationHelper.getTranslation("ig_button_edit")}}</span>
          </div>
          <div class="large-10 columns action-button" @click="deleteOffer">
            <i class="ig_icons dark-grey edit"></i>
            <span>{{translationHelper.getTranslation("ig_button_delete")}}</span>
          </div>
        </div>
      </div>
      <offer-edit
        v-if="editExpanded"
        v-model="localOffer"
        :available-offer-types="availableOfferTypes"
        :topic-id="topicId"
        :glass-item-data="glassItemData"
        :show-modal="editExpanded"
        :translationHelper="translationHelper"
        method="update"
        @saved="editOfferEnd"
        @close-window="editOfferEnd"
        @changed="offerChanged"
      />
    </div>
  </div>
</template>

<script>
import InteraktiveGrafik from "../../../../_Api/InteraktiveGrafik";
import offerEdit from "./offerEdit.vue";

export default {
  components: {
    offerEdit
  },
  model: {
    prop: "offer",
    event: "changed"
  },
  props: {
    offer: {
      type: Object,
      default: () => {}
    },
    topicId: {
      type: String,
      default: ""
    },
    glassItemData: {
      type: Object,
      default: () => {}
    },
    availableOfferTypes: {
      type: Array,
      default: () => []
    },
    translationHelper: {
      type: Object
    },
  },
  computed: {
    localOffer: {
      get() {
        return this.offer;
      },
      set(newOffer) {
        return newOffer;
      }
    }
  },
  data() {
    return {
      editExpanded: false,
    };
  },
  methods: {
    editOfferStart() {
      this.editExpanded = true;
    },
    editOfferEnd() {
      this.editExpanded = false;
    },
    deleteOffer() {
      var msg = "Angebot wirklich löschen?";
      var ok = confirm(msg);
      if (ok) {
        InteraktiveGrafik.deleteOffer({ id: this.localOffer.id }).then(
          (response) => this.deleted(response)
        );
      }
    },
    deleted(response) {
      if (response.data) {
        this.$emit("deleted", this.localOffer.id);
      }
    },
    offerChanged(changed) {
      this.$emit("changed", changed);
    },
    getOfferTypeName() {
      var found = this.availableOfferTypes.find(
        (x) => x.id === this.localOffer.offerTypeId
      );
      if (found) {
        return found.name;
      }
      return "";
    }
  }
}
</script>

<style>
</style>